import {useMemo} from 'react';
import {WalletType} from './useActiveTab';
import {NormalizedWalletTab} from './useNormalizeTabs';

export const useIsCurrentTabErrored = (
  activeTab: WalletType,
  tabs: NormalizedWalletTab[],
) => {
  return useMemo(() => {
    if (
      activeTab === 'coins' &&
      tabs.find(tab => tab.value === activeTab)?.type?.$case === 'coinsError'
    ) {
      return true;
    }

    if (
      activeTab === 'coupons' &&
      tabs.find(tab => tab.value === activeTab)?.type?.$case === 'couponsError'
    ) {
      return true;
    }

    if (
      activeTab === 'notificationCenter' &&
      tabs.find(tab => tab.value === activeTab)?.type?.$case ===
        'notificationCenterError'
    ) {
      return true;
    }

    return false;
  }, [activeTab, tabs]);
};
